import React, {useEffect, useState} from 'react';
import {
  lang,
  sessid,
  axiosConfig,
  esputnikTracker,
  eventEmitter
} from '../../../common/baseData';
import ProductButtons from './productButtons/ProductButtons';
import CreditServices from '../creditServices/CreditServices';
import { Pagination, Navigation } from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function TopProduct(props) {
  const [hoveredImage, setHoveredImage] = useState(null);
  const hasCashback = Number(props.data.PROPERTIES.CASHBACK.VALUE) > 0;
  const hasCreditPayment = Boolean(
      props.data.CREDIT_SERVICES &&
      Object.keys(props.data.CREDIT_SERVICES).length > 0 &&
      props.data.MONTHLY_PAYMENT_FORMATED
  );

  const loadActiveSlideImage = (swiper) => {
    const activeSlide = swiper.slides[swiper.activeIndex];
    const image = activeSlide?.querySelector('img[data-src]');

    if (image && !image.getAttribute('src')) {
      image.setAttribute('src', image.dataset.src);
    }
  };

  let availableState = props.data.PROPERTIES.NALICHIE.VALUE;

  const renderItemProps = () => {
    const allowedPropertyIds = props.data.UF_PR_PROPERTIES;
    let renderedPropertiesCount = 0; // Counter variable

    return Object.values(props.data.PROPERTIES).map(prop => {

      if (
          prop &&
          allowedPropertyIds.includes(parseInt(prop.ID)) &&
          isValidValue(prop.VALUE) &&
          renderedPropertiesCount < 4
      ) {
        renderedPropertiesCount++;
        return (
            <tr key={prop.ID}>
              <td className="info-name">{prop.NAME}:</td>
              <td className="info-value">{renderValue(prop.VALUE)}</td>
            </tr>
        );
      }

      return null;
    });
  };

  // Function to check if the value is valid (not empty or undefined)
  const isValidValue = (value) => {
    return value !== undefined && value !== '' &&
        !(Array.isArray(value) && value.length === 0);
  };

  const imgStyle = {
    backgroundImage: `url(${hoveredImage || props.data.IMAGE_545_SRC})`,
  };

  const handleMouseEnter = (relink) => {
    setHoveredImage(relink.IMAGE_545_SRC);
  };

  const handleMouseLeave = () => {
    setHoveredImage(null);
  };

  const renderRelinkColor = () => {
    if (props.data.COLOR_RELINK && Object.keys(props.data.COLOR_RELINK).length > 0) {
      const relinks = Object.values(props.data.COLOR_RELINK);
      return (
        <>
          {relinks.map((relink, index) => {
            return index < 5 ?
              <div
                key={relink.ID}
                className={relink.ID === props.data.ID ? 'relink-value active' : 'relink-value'}
                data-image={relink.IMAGE_545_SRC}
                onMouseEnter={() => handleMouseEnter(relink)}
                onMouseLeave={handleMouseLeave}
              >
                <a href={relink.URL}>
                  <span className={relink.CLASS_NAME}></span>
                </a>
              </div> :
              <></>;
          })}
          {relinks.length > 5 && (
            <span className="text-[12px] leading-[18px]">
              {`+${relinks.length - 5}`}
            </span>
          )}
        </>
      );
    }
  };

  const renderAdditionalImages = () => {
    if (props.data.ADDITIONAL_PHOTO && Object.keys(props.data.ADDITIONAL_PHOTO).length > 0) {
      return (
        <Swiper className={'catalog-images-slider'}
                modules={[Pagination, Navigation]}
                slidesPerView={1}
                pagination={
                  {clickable: true}
                }
                allowTouchMove={props.isMobile}
                lazy={true}
                loop={true}
                runCallbacksOnInit={false}
                navigation={!props.isMobile}
                onSlideChange={loadActiveSlideImage}>
          {/* отображаем первый слайд, главное изображение */}
          <SwiperSlide>
            <a href={props.data.URL}
               onClick={(e) => {
                 e.preventDefault();
                 props.onClick(props.data.ID, props.data.URL);
               }}
               className="product_url">
              <img
                src={hoveredImage ? hoveredImage : props.data.IMAGE_545_SRC}
                alt={lang !== 'ru' ? props.data.NAME_UA : props.data.NAME_RU}
                title={lang !== 'ru' ? props.data.NAME_UA : props.data.NAME_RU}
                style={imgStyle}
              />
            </a>
          </SwiperSlide>

          {/* добавляем следующие слайдеры, дополнительные картинки */}
          {Object.values(props.data.ADDITIONAL_PHOTO).map((picture, index) => (
            <SwiperSlide key={`viewed-${index}`}>
              <a href={props.data.URL}
                 onClick={(e) => {
                   e.preventDefault();
                   props.onClick(props.data.ID, props.data.URL);
                 }}
                 className="product_url">
                <img
                  data-src={picture.src}
                  className="catalog-lazy-image swiper-lazy"
                  alt={lang !== 'ru' ? props.data.NAME_UA : props.data.NAME_RU}
                  title={lang !== 'ru' ? props.data.NAME_UA : props.data.NAME_RU}
                  onLoad={(event) => event.currentTarget.closest('.product_url')?.classList.add('catalog-image-loaded')}
                  onError={(event) => event.currentTarget.closest('.product_url')?.classList.add('catalog-image-loaded')}
                />
                <div className="catalog-image-preloader">
                  <div className="catalog-image-preloader-holder"></div>
                </div>
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      );
    }

    return (
      <div className="catalog-images-slider"
           style={
             availableState && (availableState !== 'В наличии' && availableState !== 'Ожидается')
               ? {
                 opacity: 0.5,
                 WebkitFilter: 'opacity(50%)',
                 MozOpacity: 0.5,
               }
               : {}
           }
      >
        <a href={props.data.URL}
           onClick={(e) => {
             e.preventDefault();
             props.onClick(props.data.ID, props.data.URL);
           }}
           className="product_url">
          <img
            src={hoveredImage ? hoveredImage : props.data.IMAGE_545_SRC}
            alt={lang !== 'ru' ? props.data.NAME_UA : props.data.NAME_RU}
            title={lang !== 'ru' ? props.data.NAME_UA : props.data.NAME_RU}
          />
        </a>
      </div>
    )
  };

  // Function to render the value based on its type
  const renderValue = (value) => {
    if (Array.isArray(value)) {
      return renderArray(value);
    } else if (typeof value === 'object') {
      return renderObject(value);
    } else if (typeof value === 'string') {
      // Replace &quot; with "
      return value.replace(/&quot;/g, '"');
    }
    return value;
  };

  // Function to render an array
  const renderArray = (array) => {
    return array.join(', ');
  };

  // Function to render an object
  const renderObject = (object) => {
    // Customize based on how you want to render the object
    return JSON.stringify(object);
  };

  const renderRatingStars = (rating) => {
    const maxStars = 5;
    const filledStars = parseInt(rating, 10) || 0; // Convert rating to a number, default to 0 if not a valid number

    return Array.from({length: maxStars}, (_, index) => (
        <span key={index} className={`star-mini ${index < filledStars
            ? 'full'
            : ''}`}></span>
    ));
  };

  const favoriteIcon = () => {
    return <a className="favorite-link" href="#" onClick={(e) => {
      e.preventDefault();
    }}>
      <i className="icon-favorite"
         data-container="favorite"
         data-id={props.data.ID}
         data-link="/personal/wishlist/"
         data-use="add">
        <span className="tooltip-text">
            <span className="tooltip-text-holder">
                <span className="tooltip-box">
                    <span>{props.messages.ADD_TO_FAVORITE}</span>
                </span>
            </span>
        </span>
      </i>
    </a>;
  };

  const compareIcon = () => {
    return <a className="comparing-link" href="#"
              onClick={(e) => {e.preventDefault();}}>
      <i
          className="icon-comparing"
          data-container="compare"
          data-id={props.data.ID}
          data-link="/personal/compare/"
      >
          <span className="tooltip-text">
              <span className="tooltip-text-holder">
                  <span className="tooltip-box">
                      <span>{props.messages.ADD_TO_COMPARE}</span>
                  </span>
              </span>
          </span>
      </i>
    </a>;
  };

  const rateItem = () => {

    if (props.data.BLOG_DATA && Object.keys(props.data.BLOG_DATA).length > 0) {
      const {RATING, COMMENT_CNT, COMMENT_MESS, POST_ID} = props.data.BLOG_DATA;
      const labelRatingTemplate = props.messages[COMMENT_MESS];
      const labelRating = labelRatingTemplate.replace('#NUM#', COMMENT_CNT);
      return <div className="hidden-info">
        <div className="hidden-info-holder">
          <div className="rate-row">
            {RATING && (
                <div className="rate">
                  {renderRatingStars(RATING)}
                </div>
            )}
            <div className="product-reviews">
              <a href={`${props.data.URL}#section-testimonials`}>
                {labelRating}
              </a>
            </div>
          </div>
        </div>
      </div>;
    } else {
      return <div className="hidden-info"></div>;
    }
  };

  const [inBasket, setInBasket] = useState();

  useEffect(() => {
    // События
    initEvents();
    // Состояние купить / в корзине
    updateState();
  }, []);

  /**
   * Инициализируем события
   */
  function initEvents() {
    eventEmitter.on('basketUpdated', updateState);
  }

  /**
   * Обновляем состояние товара в корзине
   */
  function updateState() {
    setInBasket(productInBasket());
  }

  function productInBasket() {
    let basketItemsMap = JSON.parse(localStorage.getItem('basketItemsMap')) ||
        {};
    return !!basketItemsMap.hasOwnProperty(props.data.ID);
  }


  function onOpenCreditCard() {
    if (!inBasket) {
      eventEmitter.emit('showLoader');
      eventEmitter.emit('addToCart', {
        productId: props.data.ID,
        openWindow: false
      })
      eventEmitter.once('addedToCart', () => {
        eventEmitter.emit('openCreditBasket')
      })
    } else {
      eventEmitter.emit('hideLoader');
      eventEmitter.emit('openCreditBasket')
    }
  }

  /**
   * Событие добавления товара в корзину
   * @param e
   */
  function addToBasket(e) {
    e.preventDefault();
    if (productInBasket()) return;
    // отправляется событие добавления в корзину
    eventEmitter.emit('addToCart', {productId: props.data.ID});
  }

  return (
      <div className="product-item product-item-hit" data-container="product"
           data-id={props.data.ID}>
        <div className="product-label">
          <span
              className="label-top-selling">{props.messages.CT_BCI_TPL_LABEL_TOP}</span>
        </div>

        {favoriteIcon()}
        {compareIcon()}

        {renderAdditionalImages()}

        {
          props.data.hasOwnProperty('SPECIAL_DEAL') &&
          props.data.SPECIAL_DEAL.hasOwnProperty('PICTURE') &&
          props.data.SPECIAL_DEAL.PICTURE.hasOwnProperty('src') ?
              <img className="special-deal-img"
                   src={props.data.SPECIAL_DEAL.PICTURE.src}
                   alt={props.data.SPECIAL_DEAL.TITLE} loading="lazy"/> :
              <></>
        }

        <div className="product-description">
          <div className="code"><span>{props.data.PROPERTY_107_VALUE}</span>
          </div>
          <div className="product-name">
            <a href={props.data.URL}
               onClick={(e) => {
                 e.preventDefault();
                 props.onClick(props.data.ID, props.data.URL);
               }}
               title={lang !== 'ru' ?
                 props.data.NAME_UA :
                 props.data.NAME_RU}
               className="product_url">{lang !== 'ru' ?
                props.data.NAME_UA :
                props.data.NAME_RU}</a>
          </div>
          <div className="top-product-hidden-info">
            <table className="info-items-list">
              <tbody>
              {renderItemProps()}
              </tbody>
            </table>
          </div>
          <div className="relink-row">
            {renderRelinkColor()}
          </div>
          <div className="btn-buy_row">
            <div className="price-block">
              <div className={props.data.OLD_PRICE
                  ? 'price-box'
                  : 'price-box custom-style'}>
                {
                  props.data.OLD_PRICE > 0 ?
                    <div className="price-old">
                      <span>{props.data.OLD_PRICE_FORMATED}</span>
                    </div> :
                    <></>
                }
                <div className={props.data.PROPERTIES.NALICHIE.VALUE ===
                'Нет в наличии' ? 'price' : 'price'}>
                  <span>{props.data.PRICE_FORMATED}</span>
                </div>

                {
                  props.data.PROPERTIES.NALICHIE.VALUE === 'В наличии' && Number(props.data.PROPERTIES.CASHBACK.VALUE) > 0 && props.isMobile ?
                    <div className="catalog-item-cashback-holder font-normal">
                      <span>{props.messages.CT_CASHBACK}</span>
                      <span> {props.data.PROPERTIES.CASHBACK.VALUE_FORMATED}</span>
                    </div> :
                    <></>
                }
              </div>
              <div className="price-usd"></div>
            </div>

            <ProductButtons {...props} inBasket={inBasket}
                            onAddToBasket={addToBasket}
                            isMobile={props.isMobile}
                            newModelsCategory={props.newModelsCategory}/>
          </div>

          {
            props.data.PROPERTIES.NALICHIE.VALUE === 'В наличии' && (hasCashback || hasCreditPayment) && !props.isMobile ?
              <div className="catalog-item-cashback-credit-holder flex justify-between mt-[6px] items-center">
                {hasCashback && (
                  <div className="catalog-item-cashback-holder">
                    <span>{props.messages.CT_CASHBACK}</span>
                    <span> {props.data.PROPERTIES.CASHBACK.VALUE_FORMATED}</span>
                  </div>
                )}
                {hasCreditPayment && (
                  <button className="buy-btn ml-auto !text-[12px] leading-normal !border-0 text-blue-primary !p-0 !pr-[3px] !bg-transparent"
                          data-current-product-id={props.data.ID} onClick={onOpenCreditCard}>
                    <span className="text-[12px]">{props.messages.CT_BCI_TPL_PAY_LATE.replace('#PRICE#', props.data.MONTHLY_PAYMENT_FORMATED)}</span>
                  </button>
                )}
              </div> :
              <></>
          }

          {rateItem()}
        </div>
      </div>
  );
}

export default TopProduct;